export const generateGuid = () =>
  window.crypto?.randomUUID() ??
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (e) {
    const i = (16 * Math.random()) | 0;
    return ('x' === e ? i : (3 & i) | 8).toString(16);
  });
